import InputDropdown from 'components/form/inputDropdown'
import { IFieldStructure } from 'constants/valuesInterfaces/interfaces'
import { getOptionsDropDown, handleSetValueInput } from 'lib/FormUtils'
import React, { Component, Fragment } from 'react'
import { Row } from 'react-bootstrap'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'

interface IHeaderFiltersElectronicReceiptsProps extends WithTranslation {
	fields?: Array<IFieldStructure>
	filterBranches?: any
	t?: any
	values: any
	handleChange: any
	handleBlur: any
	setFieldValue: any
	setFieldTouched: any
	idOperacion?: any
}

interface IHeaderFiltersElectronicReceiptsState {
	firstRefInput: any
}

class HeaderFiltersReceipts extends Component<
	IHeaderFiltersElectronicReceiptsProps,
	IHeaderFiltersElectronicReceiptsState
> {
	constructor(props: IHeaderFiltersElectronicReceiptsProps) {
		super(props)
		this.state = {
			firstRefInput: React.createRef()
		}
	}

	render() {
		const {
			fields,
			filterBranches,
			t,
			setFieldTouched,
			setFieldValue,
			handleBlur,
			values
		} = this.props
		const formikProps = { setFieldTouched, setFieldValue }

		const branchesProps = {
			inputFormCol: { sm: 12 },
			fields,
			label: t('search_voucher.type_voucher'),
			inputId: 'sucursal',
			name: 'sucursal',
			placeholder: '',
			colLabel: 'col-sm-3',
			colInput: 'col-sm-9',
			onBlur: handleBlur,
			value: values.sucursal,
			options: getOptionsDropDown(filterBranches),
			noInitialExecute: true,
			onChange: (data: any) =>
				handleSetValueInput(data, 'sucursal', formikProps)
		}

		return (
			<Fragment>
				<Row className={`col-12`}>
					<InputDropdown {...branchesProps} />
				</Row>
			</Fragment>
		)
	}
}

const mapStateToProps = ({ searchVoucher, tableCalls }: any) => {
	const { filterBranches, sortDirOptions } = searchVoucher
	const { sortDirCbtOptions, optionsFilterAffected } = tableCalls
	return {
		filterBranches,
		sortDirCbtOptions,
		sortDirOptions,
		optionsFilterAffected
	}
}

const mapDispatchToProps = {}

const connectForm = connect(
	mapStateToProps,
	mapDispatchToProps
)(HeaderFiltersReceipts)

export default withTranslation()(connectForm)
